import React, { useState, useEffect } from "react";
import { Globals as OldGlobals} from '../../global/Globals';
import FileUploader from '../FileUploader/FileUploader';
import './ConditionalUpload.css';
import { useLanguage } from '../../context/Languagecontext';

const ConditionalUpload = ({ inputValue, isUploadRequired, setOption, tabIndex1 = 0, tabIndex2 = 0, handleVendorRegNum, disableToggle = true, }) => {
    const { Globals } = useLanguage();
    const [isYesSelected, setIsYesSelected] = useState(false);

    const handleOptions = () => {
        if (disableToggle) {
            setIsYesSelected(!isYesSelected);
            setOption(!isYesSelected);
            handleVendorRegNum && handleVendorRegNum(isYesSelected);
        }
    }
    useEffect(() => {
        if (inputValue !== undefined && inputValue !== null) {
            setIsYesSelected(inputValue);
        } else {
            setIsYesSelected(false);
        }
    }, [inputValue]);
    return (
        <>
            <div className={'base-container'}>
                <div className={'base-option'}>
                    <div className="yes-option">
                        <label className="conditional-upload-radio-label">
                            <input
                                tabIndex={tabIndex2}
                                className="conditional-upload-radio-button-text"
                                type="radio"
                                checked={isYesSelected}
                                onChange={handleOptions}
                                disabled={!disableToggle}
                            />
                            <span id="yes-label" className="yes-label">{Globals.SIGNUP.YES}</span>
                        </label>
                    </div>
                    <div className="no-option">
                        <label className="conditional-upload-radio-label">
                            <input
                                tabIndex={tabIndex1}
                                className="conditional-upload-radio-button-text"
                                type="radio"
                                checked={!isYesSelected}
                                onChange={handleOptions}
                                disabled={!disableToggle}
                            />
                            <span id="yes-label" className="yes-label">{Globals.SIGNUP.NO}</span>
                        </label>
                    </div>
                </div>
                {console.log("isrequired",isUploadRequired,isYesSelected)}
                {/* {(isUploadRequired && isYesSelected) && (
                    <div className={'file-upload-option'}>
                        <FileUploader onFileUpload={onFileUpload}/>
                    </div>
                )} */}
            </div>
        </>
    );
};

export default ConditionalUpload;